/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "aslanwebsftpapi",
            "endpoint": "https://evdoaurvk5.execute-api.eu-west-2.amazonaws.com/uat",
            "region": "eu-west-2"
        },
        {
            "name": "fileApi",
            "endpoint": "https://6jp0uzuvwa.execute-api.eu-west-2.amazonaws.com/uat",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:76488cf6-0450-452c-bc96-b585001f2e53",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_7xQE0bO5a",
    "aws_user_pools_web_client_id": "kueaujig54mhg6mu817mmib2c",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "userprofiles-uat",
            "region": "eu-west-2"
        },
        {
            "tableName": "companiesTable-uat",
            "region": "eu-west-2"
        }
    ]
};


export default awsmobile;
